import React, { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useServer } from '../contexts/ServerContext';
import { useTheme } from '../contexts/ThemeContext';
import OnlineStaff from './OnlineStaff';
import FogRawGLBackground from './FogRawGLBackground';
import Settings from './Settings';
import { 
  LayoutDashboard, 
  Users, 
  Terminal, 
  LogOut, 
  User,
  Logs,
  Swords,
  Ban,
  MapPin,
  Monitor,
  AlertTriangle,
  EthernetPort,
  Tag,
  Settings as SettingsIcon
} from 'lucide-react';
import { steamId64ToV2 } from '../utils/helpers';

function Layout() {
  const { user, logout } = useAuth();
  const { servers, server, setServer, loading: serversLoading } = useServer();
  const { enabledTabs } = useTheme();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  React.useEffect(() => {
    let category = '';
    switch (location.pathname) {
      case '/dashboard': category = 'Dashboard'; break;
      case '/punishments': category = 'Logs'; break;
      case '/pvplogs': category = 'Спасибо за файт'; break;
      case '/active-bans': category = 'Баны'; break;
      case '/reports': category = 'Репорты'; break;
      case '/observation': category = 'Обсерватория'; break;
      case '/map': category = 'Карта'; break;
      case '/players': category = 'Игроки'; break;
      case '/commands': category = 'Команды'; break;
      case '/staff': category = 'Персонал'; break;
      case '/tags': category = 'Теги'; break;
      
      default: category = '';
    }
    document.title = `юфу${category ? ' ✦ ' + category : ''}`;
  }, [location.pathname])
  React.useEffect(() => {
      setCollapsed(true);
  }, []);

  const iconMap = {
    dashboard: LayoutDashboard,
    players: Users,
    commands: Terminal,
    punishments: Logs,
    'active-bans': Ban,
    pvplogs: Swords,
    staff: User,
    reports: AlertTriangle,
    observation: Monitor,
    map: MapPin,
    tags: Tag
  };

  const navigation = enabledTabs.map(tab => ({
    name: tab.label,
    href: `/${tab.id}`,
    icon: iconMap[tab.id] || LayoutDashboard
  }));

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="min-h-screen" style={{ position: 'relative', zIndex: 1 }}>
      <FogRawGLBackground style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', zIndex: 0 }} />

      <div className={`fixed inset-y-0 left-0 z-50 bg-gmod-dark border-r border-gmod-lighterer transition-all duration-300 ${collapsed ? 'w-20' : 'w-64'}`}>
        <div className="flex flex-col h-full">

          <div className={`flex items-center justify-between border-b border-gmod-lighterer ${collapsed ? 'p-2' : 'p-6'}`}>
            <h1 className={`font-bold text-theme-primary transition-all duration-300 ${collapsed ? 'text-lg' : 'text-xl'}`}>yufu.su</h1>
          </div>

          <div className={`border-b border-gmod-lighterer flex items-center justify-center ${collapsed ? 'px-0 py-2' : 'px-4 py-2'}`}>
            {serversLoading ? (
              <span className="text-gmod-white opacity-60 text-xs">Загрузка серверов...</span>
            ) : (
              <div style={{ maxWidth: '100%', overflowX: 'auto' }} className="flex flex-row items-center w-full gap-2 scrollbar-thin scrollbar-thumb-gmod-lighterer scrollbar-track-gmod-dark">
                {servers.map((srv, idx) => (
                  <button
                    key={srv.id}
                    className={`w-8 h-8 flex items-center justify-center rounded-full mx-1 text-base font-bold transition-colors duration-200
                      ${server === srv.id ? 'bg-theme-primary text-gmod-white shadow-lg' : 'bg-gmod-lighter text-gmod-white opacity-60 hover:bg-theme-primary hover:opacity-100'}`}
                    onClick={() => {setServer(srv.id); console.log(srv)}}
                    style={{ outline: 'none' }}
                    title={srv.name || `Сервер ${idx+1}`}
                  >{srv.name ? srv.name.replace(/[^0-9]+/g, '') || idx+1 : idx+1}</button>
                ))}
              </div>
            )}
          </div>

          <nav className={`flex-1 ${collapsed ? 'px-1 py-2' : 'px-4 py-6'} space-y-2`}>
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              
              // Скрываем пункт "Теги" для не-superadmin
              if (item.name === 'Теги' && user?.rank !== 'superadmin') {
                return null;
              }
              
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center rounded-md transition-colors duration-200 ${collapsed ? 'justify-center px-0 py-2' : 'px-3 py-2 text-sm font-medium'} ${
                    isActive
                      ? 'bg-gmod-dark border-2 border-theme-primary text-theme-primary'
                      : 'text-gmod-white opacity-80 hover:bg-gmod-lighter hover:text-theme-primary'
                  }`}
                  title={item.name}
                >
                  <item.icon className={`h-5 w-5 ${collapsed ? '' : 'mr-3'}`} />
                  {!collapsed && item.name}
                </Link>
              );
            })}
            {/* Только для superadmin */}
            {user?.rank === 'superadmin' && (
              <Link
                to="/ip-stats"
                className={`flex items-center rounded-md transition-colors duration-200 ${collapsed ? 'justify-center px-0 py-2' : 'px-3 py-2 text-sm font-medium'} ${location.pathname === '/ip-stats' ? 'bg-gmod-dark border-2 border-theme-primary text-theme-primary' : 'text-theme-primary opacity-80 hover:bg-gmod-lighter hover:text-theme-primary'}`}
                title="IP-Статистика"
              >
                <EthernetPort className={`h-5 w-5 ${collapsed ? '' : 'mr-3'}`} />
                {!collapsed && 'IP-Статистика'}
              </Link>
            )}
          </nav>

          <div className={`border-t border-gmod-lighterer ${collapsed ? 'p-2' : 'p-4'}`}>
            <button
              onClick={() => setCollapsed(v => !v)}
              className={`w-full flex items-center justify-center mb-2 p-1 rounded hover:bg-gmod-lighter transition-colors`}
              title={collapsed ? 'Развернуть' : 'Свернуть'}
            >
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s'}} className="text-theme-primary">
                <path d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            {user?.steamId ? (
              <Link to={`/players/${steamId64ToV2(user.steamId)}`} className={`flex items-center mb-3 hover:opacity-80 transition-opacity ${collapsed ? 'justify-center' : ''}`}>
                <img
                  src={user?.avatar || '/default-avatar.png'}
                  alt="Avatar"
                  className={`w-8 h-8 rounded-full border-2 border-theme-primary ${collapsed ? '' : 'mr-3'}`}
                />
                {!collapsed && (
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gmod-white truncate">
                      {user?.displayName}
                    </p>
                    <p className="text-xs text-gmod-white opacity-60 truncate">
                      {steamId64ToV2(user?.steamId)}
                    </p>
                  </div>
                )}
              </Link>
            ) : (
              <div className={`flex items-center mb-3 ${collapsed ? 'justify-center' : ''}`}>
                <img
                  src={user?.avatar || '/default-avatar.png'}
                  alt="Avatar"
                  className={`w-8 h-8 rounded-full border-2 border-theme-primary ${collapsed ? '' : 'mr-3'}`}
                />
                {!collapsed && (
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gmod-white truncate">
                      {user?.displayName}
                    </p>
                    <p className="text-xs text-gmod-white opacity-60 truncate">
                      {user?.steamId}
                    </p>
                  </div>
                )}
              </div>
            )}
            <button
              onClick={() => setSettingsOpen(true)}
              className={`flex items-center w-full text-sm font-medium text-gmod-white opacity-80 rounded-md hover:bg-gmod-lighter hover:text-theme-primary transition-colors duration-200 ${collapsed ? 'justify-center px-0 py-2' : 'px-3 py-2'}`}
            >
              <SettingsIcon className={`h-4 w-4 ${collapsed ? '' : 'mr-3'}`} />
              {!collapsed && 'Настройки'}
            </button>
            <button
              onClick={handleLogout}
              className={`flex items-center w-full text-sm font-medium text-gmod-white opacity-80 rounded-md hover:bg-theme-primary hover:text-gmod-white transition-colors duration-200 ${collapsed ? 'justify-center px-0 py-2' : 'px-3 py-2'}`}
            >
              <LogOut className={`h-4 w-4 ${collapsed ? '' : 'mr-3'}`} />
              {!collapsed && 'Выйти'}
            </button>
          </div>
        </div>
      </div>

      <div className={`transition-all duration-300 ${collapsed ? 'pl-16' : 'pl-64'}`}>
        <main className="p-6">
          <Outlet />
        </main>
      </div>

      <OnlineStaff />
      <Settings isOpen={settingsOpen} onClose={() => setSettingsOpen(false)} />
      {/* <FloatingTiktok /> */}
    </div>
  );
}

export default Layout; 